import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { useState } from "react";
import {
  CurrencyDollarIcon,
  HeartIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import FormInput from "../../components/controls/FormInput";
import { useTranslation } from "react-i18next";

export default function DonationPopup({ isOpen, onClose }) {
  const [isAnonymous, setIsAnonymous] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState(0);
  const { t } = useTranslation();

  const handleDonate = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/create-donation`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            isAnonymous,
            name: isAnonymous ? null : name,
            email: isAnonymous ? null : email,
            amount,
          }),
        }
      );

      const { sessionUrl } = await response.json();
      window.location.href = sessionUrl;
    } catch (err) {
      console.error("Erreur Stripe :", err);
      alert("Erreur lors de la création de la session de don.");
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed z-50 inset-0 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen p-4 bg-black/50">
        <DialogPanel className="bg-white p-6 rounded-xl shadow-xl max-w-md w-full space-y-5 relative">
          {/* Bouton de fermeture */}
          <XMarkIcon
            className="w-6 h-6 cursor-pointer text-bgCyan absolute top-4 right-4"
            onClick={onClose}
          />

          <div className="flex items-center justify-center text-bgCyan">
            <HeartIcon className="h-8 w-8" />
          </div>
          <DialogTitle className="text-2xl font-bold text-center text-gray-800">
            Merci de soutenir notre mission
          </DialogTitle>

          <p className="text-center text-gray-600 text-sm">
            Chaque don nous aide à organiser des événements au profit de causes
            sociales au Québec. Ensemble, on peut vraiment faire une différence.
          </p>

          <div className="space-y-3">
            <label className="flex items-center gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={isAnonymous}
                onChange={() => setIsAnonymous(!isAnonymous)}
              />
              Je souhaite faire un don anonyme
            </label>

            {!isAnonymous && (
              <>
                <FormInput
                  type="text"
                  name="donatorName"
                  label={t("contactPage.nameLabel")}
                  placeholder={t("contactPage.namePlaceholder")}
                  value={name}
                  onChange={(name, value) => setName(value)}
                  className="w-full border px-3 py-2 rounded"
                  showRequiredOrOptional={false}
                />
                <FormInput
                  type="email"
                  label={t("contactPage.emailLabel")}
                  placeholder={t("contactPage.emailPlaceholder")}
                  value={email}
                  onChange={(name, value) => setEmail(value)}
                  className="w-full border px-3 py-2 rounded"
                  showRequiredOrOptional={false}
                />
              </>
            )}

            <FormInput
              type="number"
              name="donationAmount"
              value={amount}
              min={1}
              max={8000}
              label="Montant de votre don (en dollars canadiens)"
              onChange={(name, value) => {
                let numericValue = parseFloat(value);
                if (isNaN(numericValue)) return;

                // Clamp entre 1 et 8000
                if (numericValue < 1) numericValue = 10;
                if (numericValue > 8000) numericValue = 8000;

                // Arrondi à 2 décimales
                const rounded = parseFloat(numericValue.toFixed(2));
                setAmount(rounded);
              }}
              onFocus={(e) => e.target.select()}
              className="w-full border px-3 py-2 rounded"
              placeholder="Montant ($ CAD)"
              showRequiredOrOptional={true}
              required={true}
              icon={<CurrencyDollarIcon className="w-5 h-5 text-gray-500" />}
            />
          </div>

          <button
            onClick={handleDonate}
            className="w-full bg-bgCyan text-white py-2 rounded-full text-sm font-medium hover:bg-hoverCyan transition"
          >
            Faire un don
          </button>

          <p className="text-xs text-center text-gray-400 mt-2">
            Vos informations personnelles ne seront jamais partagées.
          </p>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
